/* src/app/features/exportacao/solicitacoes-honra-exportacao.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  padding-right: 853px;
  font-weight: bold;
}
/*# sourceMappingURL=solicitacoes-honra-exportacao.component.css.map */
